import { toast } from "react-toastify";

/**
 * Toast helpers with explicit ARIA politeness:
 *   - errors / warnings use `role="alert"` (assertive) so they interrupt and
 *     are announced immediately;
 *   - success / info / default use `role="status"` (polite) so they're
 *     announced without interrupting the user's current task.
 * The ToastContainer is an `aria-live="polite"` region; the per-toast role
 * sets the announcement urgency.
 */

export function displayError(message: string): void {
  toast(message, { type: "error", toastId: message, role: "alert" });
}

export function displayDefaultMessage(message: string): void {
  toast(message, { type: "default", toastId: message, role: "status" });
}

export function displayInfo(message: string): void {
  toast(message, { type: "info", toastId: message, role: "status" });
}

export function displayWarning(message: string): void {
  toast(message, { type: "warning", toastId: message, role: "alert" });
}

export function displaySuccess(message: string): void {
  toast(message, { type: "success", toastId: message, role: "status" });
}
